import type { AxiosPromise } from 'axios';

export const unwrap = <T>(req: () => AxiosPromise<T>) => async () => (await req()).data;
